import { useMutation } from 'react-query';
import { toast } from 'react-toastify';
import React from 'react';
import { httpService } from '../../../services/http.service';
import { IFormData } from '../../../flows/achOutTransfer/constants';
import { IServerErrorResponse } from '../../../types';
import { flattenServerErrorResponse } from '../../../helpers/errors.helper';
import LiliNotification, { LiliNotificationType } from '../../../DesignSystem/LiliNotification/LiliNotification';
import { LiliToastDefaultConfig } from '../../../DesignSystem/LiliToast/LiliToast';
import { endpointManager } from '../../../services/endpoint.service';

export interface IAchOutResponse {
  processTime: string;
  status: string;
  transactionId: string;
}

interface IProps {
  formData: IFormData;
  billId?: string;
  supplierId?: string;
}

export const postAchOutReview = () => {
  const { postAchOutReviewUrl } = endpointManager();

  return useMutation('send-ach-out', async ({ formData, billId, supplierId }: IProps) => {
    const { accountNumber, businessName, routingNumber, transferAmount } = formData;

    const payloadBase = {
      amount: Number(transferAmount),
      feeData: formData.feeData,
    };
    const getPayloadData = () => {
      if (billId) {
        return {
          ...payloadBase,
          supplierId,
        };
      }
      return {
        ...payloadBase,
        supplier: {
          accountName: businessName,
          accountNumber,
          routingNumber,
          businessAccount: false,
        },
      };
    };

    const payload = getPayloadData();

    const { data } = await httpService.post(postAchOutReviewUrl(billId), { ...payload });
    return data.mfaActionData;
  }, {
    onError: (error: IServerErrorResponse) => {
      const { localizedMessage } = flattenServerErrorResponse(error);
      toast(<LiliNotification undismissable type={LiliNotificationType.ERROR} text={localizedMessage} id='vendorDetailsError' />, { ...LiliToastDefaultConfig });
    },
  });
};
